import type { Ref } from 'vue'

export function useRouteFilter<T, R extends null | string | number | string[]>(
  name: string,
  defaultValue?: T,
  debounce: number | boolean = false,
): Ref<T extends infer R ? R : never> {
  const mode = 'replace'
  const route = useRoute()
  const router = useRouter()

  const setQuery = (v: any) => {
    if (name.includes('datesRange') && Array.isArray(v)) {
      if (v[1]) v = v.join('to')
      else return
    }

    nextTick(() => {
      // Making sure URL always includes filter data (needed for "conditionals' source" filters)
      setTimeout(() => {
        router[unref(mode)]({
          query: { ...route.query, [name]: v || undefined },
        })
      }, 0)
    })
  }

  const debouncedSetQuery = useDebounceFn(
    setQuery,
    debounce === true ? 250 : debounce || 0,
  )

  return computed<any>({
    get() {
      const data = route.query[name]
      if (data == null) return defaultValue ?? undefined
      if (name.includes('datesRange') && !Array.isArray(data)) {
        return data.includes('to') ? data.split('to') : undefined
      }
      if (Array.isArray(data)) return data.filter(Boolean)
      if (Array.isArray(defaultValue)) return [data]
      return name === 'search' ? data : +data || data
    },
    set(v) {
      if (debounce) debouncedSetQuery(v)
      else setQuery(v)
    },
  })
}
